import api from '../lib/axios';
// ─── Legal acts ─────────────────────────────────────────────────────────────
export async function getLegalActs(params) {
    const { data } = await api.get('/api/admin/legal-acts', { params });
    return data;
}
export async function getLegalAct(id) {
    const { data } = await api.get(`/api/admin/legal-acts/${id}`);
    return data.data;
}
/** Contrôle de légalité d'un acte déjà publié (envoi, accusé de réception @ctes). */
export async function updateLegalActTransmission(id, payload) {
    const { data } = await api.post(`/api/admin/legal-acts/${id}/transmission`, payload);
    return data.data;
}
/** Auteur du dernier acte et entités émettrices déjà utilisées, pour préremplir le formulaire. */
export async function getLegalActFormOptions() {
    const { data } = await api.get('/api/admin/legal-acts/form-options');
    return data.data;
}
export async function createLegalAct(payload) {
    const { data } = await api.post('/api/admin/legal-acts', payload);
    return data.data;
}
export async function updateLegalAct(id, payload) {
    const { data } = await api.patch(`/api/admin/legal-acts/${id}`, payload);
    return data.data;
}
export async function deleteLegalAct(id) {
    await api.delete(`/api/admin/legal-acts/${id}`);
}
export async function publishLegalAct(id, options) {
    const { data } = await api.post(`/api/admin/legal-acts/${id}/publish`, options);
    return data.data;
}
export async function unpublishLegalAct(id, reason) {
    const { data } = await api.post(`/api/admin/legal-acts/${id}/unpublish`, { reason });
    return data.data;
}
export async function getLegalActAudit(id) {
    const { data } = await api.get(`/api/admin/legal-acts/${id}/audit`);
    return data.data;
}
export async function getLegalActsAuditAll(params) {
    const { data } = await api.get('/api/admin/legal-acts/audit', { params });
    return data;
}
/** Listes des délibérations et procès-verbaux à mettre en ligne, la plus urgente d'abord. */
export async function getLegalDeadlines() {
    const { data } = await api.get('/api/admin/legal-acts/deadlines');
    return data.data;
}
/** Récapitulatif annuel (PDF) pour aider à tenir le registre papier. */
export async function getLegalActsRegister(year, kind) {
    const { data } = await api.get('/api/admin/legal-acts/register', { params: { year, kind }, responseType: 'blob' });
    return data;
}
/**
 * Versement aux archives (SEDA) d'une année : le serveur contrôle les pièces et remet un
 * lien signé de quelques minutes, que le navigateur télécharge directement (gros fichier).
 */
export async function getLegalActsSedaLink(year) {
    const { data } = await api.post('/api/admin/legal-acts/seda-link', { year });
    return data.data;
}
function documentsUrl(actId) {
    return `/api/admin/legal-acts/${actId}/documents`;
}
export async function getLegalActDocuments(actId) {
    const { data } = await api.get(documentsUrl(actId));
    return data.data;
}
/** Relance la préparation de la version publiée d'un document. */
export async function retryLegalActDocument(actId, id) {
    const { data } = await api.post(`${documentsUrl(actId)}/${id}/prepare`);
    return data.data;
}
/** Dépôt d'un PDF ; celui de l'acte remplace l'acte déjà déposé. La version publiée est préparée ensuite. */
export async function uploadLegalActDocument(actId, file, role, label) {
    const form = new FormData();
    form.append('file', file);
    form.append('role', role);
    if (label)
        form.append('label', label);
    const { data } = await api.post(documentsUrl(actId), form, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });
    return data.data;
}
export async function renameLegalActDocument(actId, id, label) {
    const { data } = await api.patch(`${documentsUrl(actId)}/${id}`, { label });
    return data.data;
}
export async function reorderLegalActAnnexes(actId, ids) {
    const { data } = await api.post(`${documentsUrl(actId)}/order`, { ids });
    return data.data;
}
export async function deleteLegalActDocument(actId, id) {
    await api.delete(`${documentsUrl(actId)}/${id}`);
}
/** Enregistre les zones ; la version publiée est refaite ensuite par le serveur (document « preparing »). */
export async function saveLegalActRedactions(actId, id, zones) {
    const { data } = await api.put(`${documentsUrl(actId)}/${id}/redactions`, { zones });
    return data.data;
}
export async function searchLegalActDocument(actId, id, q) {
    const { data } = await api.get(`${documentsUrl(actId)}/${id}/search`, { params: { q } });
    return data.data;
}
/** PDF ou image de page, servis avec l'authentification : lus en blob. */
export async function getLegalActDocumentBlob(actId, id, version) {
    const { data } = await api.get(`${documentsUrl(actId)}/${id}/file`, { params: { version }, responseType: 'blob' });
    return data;
}
export async function getLegalActDocumentPage(actId, id, page, version) {
    const { data } = await api.get(`${documentsUrl(actId)}/${id}/pages/${page}`, { params: { version }, responseType: 'blob' });
    return data;
}
// ─── Council sessions ───────────────────────────────────────────────────────
export async function saveCouncilSessionItems(id, items) {
    const { data } = await api.put(`/api/admin/council-sessions/${id}/items`, { items });
    return data.data;
}
/** Génère la liste des délibérations dans un acte en brouillon ; renvoie l'acte à publier. */
export async function prepareDeliberationsList(id) {
    const { data } = await api.post(`/api/admin/council-sessions/${id}/deliberations-list`);
    return data.data.act_id;
}
export async function getCouncilSessions(params) {
    const { data } = await api.get('/api/admin/council-sessions', { params });
    return data;
}
export async function getCouncilSession(id) {
    const { data } = await api.get(`/api/admin/council-sessions/${id}`);
    return data.data;
}
export async function createCouncilSession(payload) {
    const { data } = await api.post('/api/admin/council-sessions', payload);
    return data.data;
}
export async function updateCouncilSession(id, payload) {
    const { data } = await api.patch(`/api/admin/council-sessions/${id}`, payload);
    return data.data;
}
export async function deleteCouncilSession(id) {
    await api.delete(`/api/admin/council-sessions/${id}`);
}
// ─── PDF upload ─────────────────────────────────────────────────────────────
export async function uploadLegalDocument(file) {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('module', 'affichage_legal');
    formData.append('type', 'document');
    const { data } = await api.post('/api/v1/upload', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });
    return data.url;
}
